import { Emitter, Handler } from 'mitt';
import { Unsubscribe } from '@/common/domain/Unsubscribe';
import { BottomModalBus } from '@/common/domain/bottom-modal/BottomModalBus';
import { BottomModalOpened } from '@/common/domain/bottom-modal/BottomModalOpened';
import { BusCallback } from '@/common/domain/BusCallback';

const OPEN = 'open-bottom-modal';
const CLOSE = 'close-bottom-modal';

export class MittBottomModalBus implements BottomModalBus {
  constructor(private emitter: Emitter<any>) {}

  open(modal: BottomModalOpened<any>): void {
    this.emitter.emit(OPEN, modal);
  }

  close(): void {
    this.emitter.emit(CLOSE);
  }

  opened(callback: BusCallback<BottomModalOpened<any>>): Unsubscribe {
    const handler: Handler<BottomModalOpened<any>> = modal => callback(modal);
    this.emitter.on(OPEN, handler);
    return () => this.emitter.off(OPEN, handler);
  }

  closed(callback: BusCallback<void>): Unsubscribe {
    const handler: Handler = () => callback();
    this.emitter.on(CLOSE, handler);
    return () => this.emitter.off(CLOSE, handler);
  }
}
